import React, {useEffect, useState} from "react";
import Form from "react-bootstrap/Form";
import {Col, Row} from "react-bootstrap";
import "../../styles/common/reset-pw.scss";
import {postIsPassword, postRePassword} from "../../../api/apiClient";
import Swal from "sweetalert2";

const ResetPW = (props) => {
  const [error, setError] = useState("비밀번호를 확인해주세요.");

  const [password, setPassword] = useState({
    currentPassword: '',
    newPassword: '',
    newPasswordConfirm: ''
  });

  useEffect(() => {
    if (password.newPassword !== password.newPasswordConfirm) {
      setError("비밀번호를 확인해주세요.")
    } else {
      setError("");
    }
  }, [password])

  const handleCurrentPassword = (e) => {
    e.preventDefault();
    // console.log(e.target.value);
    setPassword((prevState) => {
      return {...prevState, currentPassword: e.target.value}
    });
  };

  const handleNewPassword = (e) => {
    e.preventDefault();
    // console.log(e.target.value);
    setPassword((prevState) => {
      return {...prevState, newPassword: e.target.value}
    });
  };

  const handleNewPasswordConfirm = (e) => {
    e.preventDefault();
    // console.log(e.target.value);
    setPassword((prevState) => {
      return {...prevState, newPasswordConfirm: e.target.value}
    });
  };

  const onSubmit = () => {
    // console.log(password);
    if (password.currentPassword === '') {
      // 비밀번호가 비어!
      setError("현재 비밀번호를 입력해주세요.")
      return;
    }

    if (password.newPassword === '') {
      // 비밀번호가 비어!
      setError("새로운 비밀번호를 입력해주세요.")
      return;
    }

    if (password.newPasswordConfirm === '') {
      // 비밀번호가 비어!
      setError("새로운 비밀번호를 확인해주세요.")
      return;
    }

    if (password.newPassword !== password.newPasswordConfirm) {
      // 패스워드가 달라!
      setError("비밀번호를 확인해주세요.")
      return;
    }

    postIsPassword(password.currentPassword)
        .then((res) => {
          // console.log(res);
          if (res.data.data.isValid) {
            // 비밀번호 확인 성공 시
            postRePassword(password).then(res => {
              let data = res.data;
              // console.log(data)
              if (data.success) {
                Swal.fire(
                    '정상적으로 처리 되었습니다!',
                    '',
                    'success'
                );
                props.onHide();
              }
            }).catch(err => {
              Swal.fire(
                  err.response.data.message,
                  '',
                  'error'
              );
            })
          } else {
            Swal.fire(
                '비밀번호가 일치하지 않습니다.',
                '',
                'error'
            );
          }
        })
        .catch((err) => {
          // console.log(err);
          setError("입력한 정보를 확인해주세요.");
        });


  };

  return (
      // <Container className={"reset-container px-4 py-5"}>
        <>
          {/*<Row className={"justify-content-center text-center mb-3"}>*/}
          {/*  <Col md={12} className={"mb-3"}>*/}
          {/*    <div className={"fs-4"}>비밀번호 변경</div>*/}
          {/*  </Col>*/}
          {/*</Row>*/}

          <Row className={"justify-content-center"}>
            <Col md={10}>
              <Form
                  // onSubmit={submitHandler}
                  className={"reset-form"}
                  id={"resetForm"}
              >
                <Row className={"justify-content-center"}>
                  <Col md={10}>
                    <Form.Group className="mb-4" controlId="currentPassword">
                      <Form.Label>
                        현재 비밀번호
                      </Form.Label>
                      <Form.Control
                          type="password"
                          placeholder="현재 비밀번호"
                          className={"form-control input-pw"}
                          onChange={(e) => {
                            handleCurrentPassword(e)
                          }}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={10}>
                    <Form.Group className="mb-4" controlId="newPassword">
                      <Form.Label>
                        새로운 비밀번호
                      </Form.Label>
                      <Form.Control
                          type="password"
                          placeholder="새로운 비밀번호"
                          className={"form-control input-pw"}
                          onChange={(e) => {
                            handleNewPassword(e)
                          }}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={10}>
                      <Form.Label>
                        새로운 비밀번호 확인
                      </Form.Label>
                    <Form.Group className="" controlId="newPasswordConfirm">
                      <Form.Control
                          type="password"
                          placeholder="새로운 비밀번호 확인"
                          className={"form-control input-pw"}
                          onChange={(e) => {
                            handleNewPasswordConfirm(e)
                          }}
                      />
                    </Form.Group>
                  </Col>

                </Row>
              </Form>
            </Col>
          </Row>

          <Row>
            {error !== "" ? (
                <Col md={12} className={"error text-center text-danger mb-3"}>
                  {error}
                </Col>
            ) : ("")}
          </Row>

          {/*<Row className={"justify-content-center text-center"}>*/}
          {/*  <Col md={5}>*/}
          {/*    <Button*/}
          {/*        type={"button"}*/}
          {/*        className={"btn w-75"}*/}
          {/*        onClick={onSubmit}*/}
          {/*    >*/}
          {/*      비밀번호 변경하기</Button>*/}
          {/*  </Col>*/}
          {/*  <Col md={5}>*/}
          {/*    <Button*/}
          {/*        type={"button"}*/}
          {/*        className={"btn w-75 btn-secondary"}*/}
          {/*        onClick={props.onHide}*/}
          {/*    >*/}
          {/*      취소*/}
          {/*    </Button>*/}
          {/*  </Col>*/}
          {/*</Row>*/}
        </>
  );
};

export default ResetPW;
